// extracted by mini-css-extract-plugin
export var combosAndOdds = "ComplexBetPill-module--combosAndOdds--85449";
export var isWon = "ComplexBetPill-module--isWon--519e2";
export var logoContainer = "ComplexBetPill-module--logoContainer--39924";
export var logoIcon = "ComplexBetPill-module--logoIcon--0ac9b";
export var pillContainer = "ComplexBetPill-module--pillContainer--c5df5";